import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';

interface PerformanceData {
    totalReturn: number;
    winRate: number;
    profitFactor: number;
    maxDrawdown: number;
    sharpeRatio: number;
    sortinoRatio: number;
    calmarRatio: number;
}

interface PerformanceChartProps {
    data: PerformanceData;
}

export function PerformanceChart({ data }: PerformanceChartProps) {
    const chartData = [
        { name: 'Total Return', value: data.totalReturn, suffix: '%' },
        { name: 'Win Rate', value: data.winRate, suffix: '%' },
        { name: 'Profit Factor', value: data.profitFactor, suffix: '' },
        { name: 'Max Drawdown', value: Math.abs(data.maxDrawdown), suffix: '%' },
        { name: 'Sharpe Ratio', value: data.sharpeRatio, suffix: '' },
    ];

    return (
        <div className="w-full h-[400px]">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={chartData}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 100, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#1f2937" />
                    <XAxis type="number" hide />
                    <YAxis
                        type="category"
                        dataKey="name"
                        stroke="#9ca3af"
                        fontSize={12}
                        width={90}
                    />
                    <Tooltip
                        contentStyle={{ backgroundColor: '#111827', border: '1px solid #1f2937' }}
                        formatter={(value: number, name: string, props: any) => [`${value}${props.payload.suffix}`, name]}
                    />
                    <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                        {chartData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.name === 'Max Drawdown' ? '#ef4444' : '#3b82f6'}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
